<template>
  <div class="animated fadeIn">
    <div v-if="entity.form">
      <flash :fields="['UnprocessableEntity']"></flash>

      <b-form v-if="show" @submit.prevent.stop="formSubmit" @reset.prevent="formReset">
        <component :form="form"
          :submitted="submitted"
          :is="entity.form"
          :instance="instance"
          :http="http"
          :nested="nested"
          :parent-entity="parentEntity"
          @refresh="refreshInstance">
          <div slot="footer" class="text-right">
            <b-button v-if="hasChanges" type="reset" variant="link">
              Limpar alterações
            </b-button>

            <b-button type="submit" variant="success" :disabled="processing">
              Salvar
            </b-button>
          </div>
        </component>
      </b-form>
    </div>
  </div>
</template>

<script>
  import { get, omit, has, isEqual } from 'lodash'
  import { mapActions } from 'vuex'
  import Form from '@/services/form'

  export default {
    props: {
      http: {
        type: Object,
        required: true
      },

      entity: {
        type: Object,
        required: true
      },

      nested: {
        type: Boolean,
        default: false
      },

      parentEntity: {
        type: Object,
        default () { return {} }
      }
    },

    data () {
      return {
        // Form data
        form: new Form({}),
        method: 'put',
        action: '',

        // Form handling
        processing: false,
        show: false,
        submitted: false,

        // Entity
        instance: {}
      }
    },

    watch: {
      '$route' (to, from) {
        let next = get(to, 'path', null)
        let prev = get(from, 'path', null)

        if (next !== prev) {
          this.refreshInstance()
        }
      }
    },

    computed: {
      hasChanges () {
        return !isEqual(this.form.data(), this.form.initial)
      }
    },

    methods: {
      ...mapActions({
        clearError: 'errors/clearError'
      }),

      formSubmit () {
        const self = this

        // Lets clear the uprocessableEntity errors
        self.clearError(['UnprocessableEntity'])

        self.processing = true
        self.submitted = false

        // Before sending the form lets omit some paths
        self.form.populate(omit(self.form.data(), get(self.entity, 'formOptions.omit', [])))
        self.form[self.method](self.http.getRoute('update', self.instance.id))
          .then(([data, res]) => {
            self.submitted = true
            self.processing = false

            self.$toasted.success('Atualização realizada com sucesso')

            self.$emit('submitted', [data, res])
            self.form.setInitialValues(data)

            // Updates the instance
            self.refreshInstance()
          }).catch((e) => {
            self.submitted = true
            self.processing = false
          })
      },

      formReset () {
        /* Reset our form values */
        this.form.reset()
        this.processing = false
        this.submitted = false

        /* Trick to reset/clear native browser form validation state */
        this.show = false
        this.$nextTick(() => { this.show = true })
      },

      refreshInstance () {
        const self = this

        self.$Progress.start()
        self.http.show(
          !self.nested ? self.$route.params.id : self.$route.params.nestedId,
          (has(self.entity, 'formOptions') ? self.entity.formOptions.api : {}) || {}
        ).then((res) => {
          self.instance = res.data
          self.form = new Form(self.instance, { resetOnSuccess: false })

          self.show = false
          self.$nextTick(() => {
            self.$Progress.finish()
            self.show = true
          })
        })
      }
    },

    created () {
      // Gets the updated instance
      this.refreshInstance()

      this.action = this.http.getRoute('update', this.$route.params.id)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/manageables/Edit.vue